<template>
    <div class="icon" :class="icon">
        <svg v-if="icon === 'clear'" version="1.1" viewBox="0 0 12.8 12.8">
            <g fill="none" stroke="#000000" stroke-width="1.25">
                <line stroke="#000000" stroke-width="1.25" x1="0.4" y1="0.4" x2="12.4" y2="12.4"/>
                <line stroke="#000000" stroke-width="1.25" x1="0.4" y1="12.4" x2="12.4" y2="0.4"/>
            </g>
        </svg>

        <svg v-else-if="icon === 'close'" version="1.1" viewBox="0 0 23.5 23.5">
            <g fill="none" stroke="#000000" stroke-width="1.25">
                <line stroke="#000000" stroke-width="1.884" x1="0.7" y1="0.7" x2="22.9" y2="22.9"/>
                <line stroke="#000000" stroke-width="1.884" x1="0.7" y1="22.9" x2="22.9" y2="0.7"/>
            </g>
        </svg>

        <svg v-else-if="icon === 'edit'" version="1.1" viewBox="0 0 20 20">
            <g fill="none" stroke="#000000" stroke-width="1.25">
                <polygon stroke="#000000" stroke-width="1.25"
                         points="0.6,11.7 0.6,19.4 7.7,19.4 19.2,7.9 12.1,0.9 	"/>
            </g>
            <line stroke="#000000" stroke-width="1.25" x1="3.8" y1="13.7" x2="12.8" y2="4.7"/>
            <line stroke="#000000" stroke-width="1.25" x1="6.2" y1="16.1" x2="15.2" y2="7.1"/>
            <polygon points="0.6,19.4 4.4,19.4 0.6,15.6 "/>
        </svg>

        <svg v-else-if="icon === 'magnifier'" version="1.1" viewBox="0 0 11.7 14.7">
            <g fill="none" stroke="#000000" stroke-width="1.25">
                <circle stroke="#000000" stroke-width="1.25" cx="5.9" cy="5.9" r="5.2"/>
                <line stroke="#000000" stroke-width="1.25" x1="3.2" y1="10.3" x2="0.8" y2="14.3"/>
            </g>
        </svg>

        <svg v-else-if="icon === 'warning'" version="1.1" viewBox="-1 -1 16 16" width="14">
            <g>
                <path fill="#D13260" d="M7,14c3.9,0,7-3.1,7-7s-3.1-7-7-7S0,3.1,0,7S3.1,14,7,14"/>
                <g>
                    <path fill="#FFFFFF" d="M6.3,10.9C6.1,10.7,6,10.5,6,10.2c0-0.3,0.1-0.5,0.3-0.7C6.5,9.3,6.7,9.2,7,9.2c0.3,0,0.5,0.1,0.7,0.3
			C8,9.7,8.1,9.9,8.1,10.2c0,0.3-0.1,0.5-0.3,0.7c-0.2,0.2-0.5,0.3-0.8,0.3C6.7,11.2,6.5,11.1,6.3,10.9z M6.4,8.2l-0.1-5
			c0-0.1,0.1-0.2,0.2-0.2h1.2c0.1,0,0.2,0.1,0.2,0.2l-0.2,5c0,0.1-0.1,0.2-0.2,0.2H6.6C6.5,8.4,6.4,8.4,6.4,8.2z"/>
                </g>
            </g>
        </svg>
    </div>
</template>

<script>
    export default {
        name: "Icon",
        props: {
            'icon': {
                type: String,
                required: true
            }
        }
    }
</script>